import { breadcrumbSchema, clinicListSchema } from "../structured-data-core";
import { clinicsIn } from "../clinics";

// A hub page lists the clinics and links to each clinic's own page. The
// clinic nodes live on those pages, not here.
export function getDallasStructuredData() {
  return [
    clinicListSchema("RESTORE Hair clinics in Dallas and Texas", "/locations/restore-dallas/", clinicsIn("dallas")),
    breadcrumbSchema([
      { name: "Locations", path: "/locations/" },
      { name: "Dallas", path: "/locations/restore-dallas/" },
    ]),
  ];
}
